import { UserOrganization } from '@/common/models';
import { useUserOrganizations } from '@/org-app/services/tanstack/queries/userOrganizations.queries';
import { runQueryInScope } from '@/org-app/services/tanstack/queryUtils';

class UsersService {
  private resultPromise: Promise<{ items: UserOrganization[] }>;

  constructor() {
    this.resultPromise = null;
  }

  /**
   * Fetches the users from the backend only once per lifecycle of `UsersService` to reduce backend requests and improve performances
   * @private
   */
  private fetchUsers(): Promise<UserOrganization[]> {
    return runQueryInScope(useUserOrganizations);
  }

  /**
   * Fetches the `UserOrganization` for a given `userID`
   * @param userID {number}
   */
  public async fetchUser(userID: number): Promise<UserOrganization> {
    const users = await this.fetchUsers();
    return users.find((u) => u.userID === userID);
  }
}

/**
 * A Singleton of `UsersService`
 */
export default new UsersService();
